const live = process.env.NODE_ENV === 'production' ? 'https://startup-club.co.uk' : 'http://localhost:25000';

export const url = process.env.NODE_ENV === 'production' ? live : 'http://localhost:3001';
export const serverUrl = process.env.NODE_ENV === 'production' ? live : 'http://localhost:25000';
export const apiUrl = serverUrl + '/api';

export default {
    url,
    serverUrl,
    apiUrl
}


// WEBPACK FOOTER //
// ./src/js/config/site.js